/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expected_Academic_DegreeInputs */

const en_expected_academic_degree = /** @type {(inputs: Expected_Academic_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected Academic Degree`)
};

const de_expected_academic_degree = /** @type {(inputs: Expected_Academic_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erwarteter Studienabschluss`)
};

/**
* | output |
* | --- |
* | "Expected Academic Degree" |
*
* @param {Expected_Academic_DegreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const expected_academic_degree = /** @type {((inputs?: Expected_Academic_DegreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expected_Academic_DegreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_expected_academic_degree(inputs)
	return en_expected_academic_degree(inputs)
});